import customDialogReducer from './customDialogReducer';

export default customDialogReducer;